// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__28xKp","title":"Card_title__29Qag","hr":"Card_hr__wfRlc"};